import React from 'react';
import Relay from 'react-relay';
import { connect } from 'react-redux';
import GlobalHeader from './GlobalHeader';
import Footer from 'depop/components/layout/footer/Footer';
import FullPageNav from 'depop/components/layout/menu/FullPageNav';

import LazyModal from 'depop/components/modal/LazyModal';

import Fixit from 'depop/components/Fixit';

import { pure } from 'recompose';

class AppNavigation extends React.Component {
  props: {
    viewer: Object,
    hideFooter: boolean,
    showSearch: () => void,
  };

  constructor(props) {
    super(props);
    this.state = {
      fullPageNavExpanded: false,
      searchExpanded: false,
      isDownloadAppVisible: false,
    };
  }

  toggleFullPageNav = () => {
    const { fullPageNavExpanded } = this.state;
    if (fullPageNavExpanded) {
      this.setState({
        fullPageNavExpanded: false,
      });
    } else {
      this.setState({
        fullPageNavExpanded: true,
        searchExpanded: false,
        isDownloadAppVisible: false,
      });
    }
  };

  hideDownloadApp = () => {
    this.setState(state => {
      if (state.isDownloadAppVisible) {
        return { isDownloadAppVisible: false };
      }
    });
  };

  showDownloadApp = () => {
    this.setState(state => {
      if (!state.isDownloadAppVisible) {
        return {
          isDownloadAppVisible: true,
          fullPageNavExpanded: false,
          searchExpanded: false,
        };
      }
    });
  };

  toggleSearch = () => {
    const { searchExpanded } = this.state;
    if (searchExpanded) {
      this.setState({
        searchExpanded: false,
      });
    } else {
      this.setState({
        fullPageNavExpanded: false,
        searchExpanded: true,
        isDownloadAppVisible: false,
      });
    }
  };

  handleSearch = () => {
    this.setState({
      searchExpanded: false,
    });
  };

  render() {
    const { viewer, showSearch, hideFooter } = this.props;
    const {
      fullPageNavExpanded,
      searchExpanded,
      isDownloadAppVisible,
    } = this.state;
    const { toggleSearch, toggleFullPageNav } = this;

    return (
      <div>
        <Fixit>
          {(isFixed, fixedProgress) => (
            <div>
              <GlobalHeader
                toggleFullPageNav={toggleFullPageNav}
                toggleDownloadAppModal={this.showDownloadApp}
                toggleSearch={toggleSearch}
                searchExpanded={searchExpanded}
                showSearch={showSearch}
                onSearch={this.handleSearch}
                isFixed={isFixed}
                fixedProgress={fixedProgress}
                viewer={viewer}
              />
            </div>
          )}
        </Fixit>
        {fullPageNavExpanded &&
          <FullPageNav
            toggle={toggleFullPageNav}
            isExpanded={fullPageNavExpanded}
            toggleDownloadAppModal={this.showDownloadApp}
            viewer={viewer}
          />}

        <LazyModal
          isOpened={isDownloadAppVisible}
          onClose={this.hideDownloadApp}
          load={() =>
            import('../../../components/TextMeTheApp').then(
              module => module.default,
            )}
          render={TextMeTheApp => (
            <TextMeTheApp onClose={this.hideDownloadApp} />
          )}
        />
        {!hideFooter && <Footer />}
      </div>
    );
  }
}

const mapStateToProps = ({ userAgent, overlays }) => ({
  userAgent,
  overlays,
});

const connectedView = connect(mapStateToProps)(AppNavigation);

export default Relay.createContainer(pure(connectedView), {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        ${FullPageNav.getFragment('viewer')}
        ${GlobalHeader.getFragment('viewer')}
        currentUser {
          publicId
          username
        }
      }
    `,
  },
});



// WEBPACK FOOTER //
// ../src/client/root/containers/components/AppNavigation.js